var _windowEnv$config;

import { LOG_LEVEL } from './constants';
const windowEnv = window.env;
const loggerConfig = (_windowEnv$config = windowEnv.config) === null || _windowEnv$config === void 0 ? void 0 : _windowEnv$config.logger;
const AUTO_FLUSH_LEVEL = [LOG_LEVEL.WARN, LOG_LEVEL.ERROR];
const LOG_LEVEL_PRIORITY = [LOG_LEVEL.ERROR, LOG_LEVEL.WARN, LOG_LEVEL.INFO, LOG_LEVEL.DEBUG]; // flush log buffer every 60 seconds

const FLUSH_INTERVAL = (loggerConfig === null || loggerConfig === void 0 ? void 0 : loggerConfig.flushInterval) || 60 * 1000;
const DEFAULT_LOG_LEVEL = (loggerConfig === null || loggerConfig === void 0 ? void 0 : loggerConfig.logLevel) || LOG_LEVEL.DEBUG;
const DEFAULT_MAX_RETRIES = (loggerConfig === null || loggerConfig === void 0 ? void 0 : loggerConfig.maxRetries) || 0;
export { AUTO_FLUSH_LEVEL, LOG_LEVEL_PRIORITY, FLUSH_INTERVAL, DEFAULT_LOG_LEVEL, DEFAULT_MAX_RETRIES };